import React, { useEffect, useMemo, useState } from 'react';
import { LinearProgress } from '@material-ui/core';
import { observer } from 'mobx-react';
import BooksStore from '../../../../stores/BooksStore';
import BookListResults from '../../../book/BookListResults';
import { setMainBookDefault } from '../../../../services/api';

const LinkedBooksTab = observer(({ mainBookFormStore, userStore, onCountLoaded }) => {
  const bookStore = useMemo(() => new BooksStore(userStore), [userStore]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!mainBookFormStore.formData.id) {
      setLoading(false);
      return;
    }

    setLoading(true);
    bookStore.filters = { mainBookId: mainBookFormStore.formData.id };
    bookStore.loadAll().then(() => {
      bookStore.books = [
        ...bookStore.books.filter(b => b.is_main_default),
        ...bookStore.books.filter(b => !b.is_main_default),
      ];
      onCountLoaded?.(bookStore.totalBooks);
      setLoading(false);
    });
  }, [mainBookFormStore.formData.id]);

  const handleSetDefault = async (book) => {
    await setMainBookDefault(book.book_id, userStore.token);
    bookStore.books = [
      { ...book, is_main_default: true },
      ...bookStore.books.filter(b => b.book_id !== book.book_id).map(b => ({ ...b, is_main_default: false })),
    ];
  };

  if (loading || bookStore.isLoading) {
    return <LinearProgress />;
  }

  return (
    <BookListResults bookStore={bookStore} userStore={userStore} hidePagination hideMainBookColumn hideListColumn showDefaultColumn onSetDefault={handleSetDefault} />
  );
});

export default LinkedBooksTab;
